angular.module('unica_invitation.invitation_services')

.factory('InvitationListService', function ($http, getBaseApiURL) {

	var invitationListService = {};

	invitationListService.list = function (invitationListId, limit, offset)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation/list/' + invitationListId,
			data: {
				limit: limit,
				offset: offset
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitations;
			}

		});
	};


	invitationListService.fullList = function (invitationListId, approvationListId )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation/full-list/' + invitationListId + ( approvationListId ? '/' + approvationListId : ''),
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.invitations;
			}

		});
	};


	invitationListService.simpleList = function ( eventId )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation/simple-list/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.invitations;
			}

		});
	};


	invitationListService.listByEvent = function (eventId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation/list-by-event/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.invitations;
			}

		});
	};


	invitationListService.listByEventNoRooms = function (eventId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation/list-by-event-no-rooms/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.invitations;
			}

		});
	};


	invitationListService.listByEventNoTransfers = function (eventId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation/list-by-event-no-transfers/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.invitations;
			}

		});
	};


	invitationListService.get = function (invitationId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation/detail/' + invitationId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.data;
			}

		});
	};


	invitationListService.getByHash = function (hash)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation/detail-by-hash/' + hash,
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};


	invitationListService.search = function (eventId, term)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation/search/' + eventId,
			data: {
				search: term
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitations;
			}

		});
	};


	invitationListService.searchInList = function (invitationListId, term, limit, offset)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation/search-in-list/' + invitationListId,
			data: {
				search: term,
				limit: limit,
				offset: offset
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitations;
			}

		});
	};

	return invitationListService;
});